import { Money, Scales, Truck, ShieldCheck } from "@phosphor-icons/react";

const ICONS = { Money, Scales, Truck, ShieldCheck };

const ITEMS = [
  {
    icon: "Money",
    title: "Pagamento na hora",
    desc: "Pesou, fechou, pagou. Dinheiro, PIX ou transferência — você escolhe.",
  },
  {
    icon: "Scales",
    title: "Pesagem justa",
    desc: "Balança aferida e conferência aberta. Você vê o número antes de fechar.",
  },
  {
    icon: "Truck",
    title: "Retirada rápida",
    desc: "Buscamos seu material em Maringá e região, combinando hora pelo WhatsApp.",
  },
  {
    icon: "ShieldCheck",
    title: "Empresa séria",
    desc: "Endereço fixo, atendimento direto e preço transparente. Sem enrolação.",
  },
];

export default function TrustSection() {
  return (
    <section
      id="confianca"
      data-testid="trust-section"
      className="py-20 sm:py-28 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10 sm:mb-14">
          <div>
            <div className="label-eyebrow mb-3">[ Por que nos escolher ]</div>
            <h2 className="font-display font-bold text-white text-3xl sm:text-5xl tracking-tight max-w-3xl">
              Pago certo, peso justo,<br />
              <span className="text-[var(--rc-copper-bright)]">retirada de verdade.</span>
            </h2>
          </div>
          <p className="text-zinc-400 max-w-md text-sm sm:text-base leading-relaxed">
            Quem vende sucata quer saber se a empresa é séria. Em Maringá, a Ricatto Metais
            é referência em compra de cobre e alumínio.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {ITEMS.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <div
                key={item.title}
                data-testid={`trust-item-${i}`}
                className="bg-[var(--rc-surface)] p-7 sm:p-9 group hover:bg-[var(--rc-surface-2)] transition-colors"
              >
                <div className="w-12 h-12 grid place-items-center bg-[var(--rc-copper)]/10 border border-[var(--rc-copper)]/30 text-[var(--rc-copper-bright)] mb-5">
                  <Icon size={26} weight="duotone" />
                </div>
                <div className="font-mono-ui text-[10px] tracking-[0.22em] text-zinc-500 mb-2">
                  0{i + 1} / 0{ITEMS.length}
                </div>
                <h3 className="font-display font-bold text-white text-xl mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
